import React from 'react';
import { Field } from 'redux-form';
import { Button } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import ModalInformation from '../../components/modals/ModalInformation';
import {
  getNote1_histologicalTumorType,
  getNote2_histologicalGrade,
  getNote3_tumorExtent,
  getNote4_perineuralInvasion,
  getNote5_semicalVesicleEjaculatoryDuctInvasion,
  getNote6_lymphovascularInvasion,
  getNote7_extraprostaticExtension,
  getNote8_intraductalCarcinomaOfProstate,
  getNote9_coexistentPathology,
} from '../../constants/modal_content/PART_2_CASE_LEVEL_REPORTING';
import {
  maxValue100,
  number,
  maxValue2,
  maxValue1,
  maxValue3,
  maxValue4,
  maxValue5,
  maxValue6,
  maxValue7,
  maxValue8,
  maxValue9,
  maxValue10,
} from '../shared/Validation';
import ModalConfirm from '../../components/modals/ModalConfirm';
import ModalConfirmContainer from '../../containers/ModalConfirmContainer';

export const histologicalTumorTypeJSX = (fieldsDataList, getFieldValue) => {
  const tumourTypeFieldData = fieldsDataList.find(field => field.name === 'tumourType');
  const tumourTypeSpecifiedFieldData = fieldsDataList.find(field => field.name === 'tumourTypeSpecified');

  const tumourTypeShouldRender = tumourTypeFieldData !== undefined;
  const tumourTypeSpecifiedShouldRender = tumourTypeSpecifiedFieldData !== undefined;

  const fieldGroupShouldRender = tumourTypeShouldRender || tumourTypeSpecifiedShouldRender;

  return (
    <>
      {fieldGroupShouldRender && (
        <div className="field-container">
          <p className="main-label">
            Histological tumour type
            <ModalInformation>
              {getNote1_histologicalTumorType()}
            </ModalInformation>
          </p>
          {tumourTypeShouldRender && (
            <Field
              {...tumourTypeFieldData}
              className="field"
            />
          )}
          {tumourTypeSpecifiedShouldRender && (
            <Field
              {...tumourTypeSpecifiedFieldData}
              className="field"
              disabled={getFieldValue('tumourType') !== 'other'}

            />
          )}
        </div>
      )}
    </>
  );
};


export const histololicalGradeJSX = (fieldsDataList, getFieldValue, setFieldValue) => {
  /* The purpose of following code is to make it easy to exclude fields AND the 
  sorrounding containers containing labels, divs and other field related stuff...
  
  The fieldDataList is filtered by the parent, thats why some fields will be undefined.
  */

  // make objects of each fieldData
  const primaryGradeFieldData = fieldsDataList.find(field => field.name === 'primaryGrade');
  const highestRemainingGradeFieldData = fieldsDataList.find(field => field.name === 'highestRemainingGrade');
  const specifyGradeIndeterminatedReasonFieldData = fieldsDataList.find(field => field.name === 'specifyGradeIndeterminatedReason');
  const gradeSpecifiedFieldData = fieldsDataList.find(field => field.name === 'gradeSpecified');

  const isupGradeFieldData = fieldsDataList.find(field => field.name === 'isupGrade');
  const isupGradeSpecifiedFieldData = fieldsDataList.find(field => field.name === 'isupGradeSpecified');

  const percentageGleasonPatternFieldData = fieldsDataList.find(field => field.name === 'percentageGleasonPattern');
  const specifyGleasonPatternPercentageFieldData = fieldsDataList.find(field => field.name === 'specifyGleasonPatternPercentage');

  // check if fieldData is present
  const primaryGradeShouldRender = primaryGradeFieldData !== undefined;
  const highestRemainingGradeShouldRender = highestRemainingGradeFieldData !== undefined;
  const specifyGradeIndeterminatedReasonShouldRender = specifyGradeIndeterminatedReasonFieldData !== undefined;
  const gradeSpecifiedShouldRender = gradeSpecifiedFieldData !== undefined;

  const isupGradeShouldRender = isupGradeFieldData !== undefined;
  const isupGradeSpecifiedShouldRender = isupGradeSpecifiedFieldData !== undefined;


  const percentageGleasonPatternShouldRender = percentageGleasonPatternFieldData !== undefined;
  const specifyGleasonPatternPercentageShouldRender = specifyGleasonPatternPercentageFieldData !== undefined;

  // check if fieldData as group is present
  const gleasonPatternFieldGroupShouldRender = percentageGleasonPatternShouldRender
    || specifyGleasonPatternPercentageShouldRender;

  const isupGradeFieldGroupShouldRender = isupGradeShouldRender
    || isupGradeSpecifiedShouldRender;

  const gleasonScoreFieldGroupShouldRender = primaryGradeShouldRender
    || highestRemainingGradeShouldRender
    || specifyGradeIndeterminatedReasonShouldRender
    || gradeSpecifiedShouldRender;


  // check if any fieldData is present
  const fieldGroupsShouldRender = [
    gleasonScoreFieldGroupShouldRender,
    isupGradeFieldGroupShouldRender,
    gleasonPatternFieldGroupShouldRender,
  ].includes(true);



  const clearIsupIfValuesExist = () => {
    if (getFieldValue('isupGrade') && getFieldValue('isupGrade') !== 'false') {
      window.alert('By choosing to set gleason score, ISUP grade will be cleared.');
      setFieldValue('isupGrade', false);
      setFieldValue('isupGradeSpecified', null);
    }
  };

  const clearGleasonIfValuesExist = () => {
    if ((getFieldValue('primaryGrade') && getFieldValue('primaryGrade') !== 'false')
      || (getFieldValue('highestRemainingGrade') && getFieldValue('highestRemainingGrade') !== 'false')
      || (getFieldValue('specifyGradeIndeterminatedReason') && getFieldValue('specifyGradeIndeterminatedReason') !== false)
      || (getFieldValue('gradeSpecified') && getFieldValue('gradeSpecified') !== '')) {
      window.alert('By choosing to set ISUP grade, gleason score will be cleared.');

      setFieldValue('primaryGrade', false);
      setFieldValue('highestRemainingGrade', false);
      setFieldValue('specifyGradeIndeterminatedReason', false);
      setFieldValue('gradeSpecified', null);
    }
  };

  const setGleasonScoreToIndeterminate = () => {
    clearIsupIfValuesExist();
    setFieldValue('primaryGrade', false);
    setFieldValue('highestRemainingGrade', false);
  };

  const setGleasonScoreValue = () => {
    clearIsupIfValuesExist();
    if (getFieldValue('specifyGradeIndeterminatedReason')) {
      setFieldValue('specifyGradeIndeterminatedReason', false);
      setFieldValue('gradeSpecified', null);
    }
  };

  const onSetPercentGleasonPatternToNotIdentidied = () => {
    setFieldValue('percentageGleasonPattern', null);
  }


  const gleasonScore = (
    <div className="field-container">

      <p>
        <span>Gleason score</span>
      </p>
      {gleasonScoreFieldGroupShouldRender && (
        <>
          {primaryGradeShouldRender && (
            <div className="field-container primaryGrade">
              <p>Primary pattern/grade</p>
              <Field
                {...primaryGradeFieldData}
                className="field"
                onChange={setGleasonScoreValue}
                validationTrigger={getFieldValue('highestRemainingGrade') && getFieldValue('highestRemainingGrade') !== 'false'}
                disabled={getFieldValue('specifyGradeIndeterminatedReason')}
              />
            </div>
          )}

          {highestRemainingGradeShouldRender && (
            <div className="field-container highestRemainingGrade">
              <p> Highest remaining pattern/grade</p>
              <Field
                {...highestRemainingGradeFieldData}
                className="field"
                onChange={setGleasonScoreValue}
                validationTrigger={getFieldValue('primaryGrade') && getFieldValue('primaryGrade') !== 'false'}
                disabled={getFieldValue('specifyGradeIndeterminatedReason')}

              />
            </div>
          )}
          {specifyGradeIndeterminatedReasonShouldRender && (
            <Field
              {...specifyGradeIndeterminatedReasonFieldData}
              className="field"
              label={(
                <>
                  Indeterminate
                  {' '}
                  <i>(specify reason)</i>
                </>
              )}
              onChange={setGleasonScoreToIndeterminate}
            />
          )}
          {gradeSpecifiedShouldRender && (
            <Field
              {...gradeSpecifiedFieldData}
              className="field"
              disabled={!getFieldValue('specifyGradeIndeterminatedReason')}
            />
          )}
        </>
      )}
    </div>
  );

  const isupGradeGroup = (
    <div className="field-container">

      {isupGradeFieldGroupShouldRender && (
        <>
          <div className="sub-label-container">
            <p>
              International Society of Urological Pathology (ISUP)
            </p>
          </div>

          {isupGradeShouldRender && (
            <Field
              {...isupGradeFieldData}
              className="radio-group field"
              onChange={clearGleasonIfValuesExist}
            />
          )}
          {isupGradeSpecifiedShouldRender && (
            <Field
              {...isupGradeSpecifiedFieldData}
              className="field"
              disabled={getFieldValue('isupGrade') !== 'other'}
            />
          )}
        </>
      )
      }
    </div>
  );

  const percentageGleasonPattern = (
    <div className="field-container">

      {gleasonPatternFieldGroupShouldRender && (
        <>
          <div className="sub-label-container">
            <p>
              Percentage Gleason Pattern 4/5 &nbsp;
              <span>
                (applicable for Gleason score ≥ 7)
              </span>
            </p>
          </div>
          <div className="percentage-gleason-pattern-container">
            {percentageGleasonPatternShouldRender && (
              <Field
                {...percentageGleasonPatternFieldData}
                disabled={getFieldValue('specifyGleasonPatternPercentage')}
                className="field percentageGleasonPattern"
                validate={[maxValue100, number]}


              />
            )}
            {specifyGleasonPatternPercentageShouldRender && (
              <Field
                {...specifyGleasonPatternPercentageFieldData}
                className="field"
                label="Not identified"
                onChange={onSetPercentGleasonPatternToNotIdentidied}
              />
            )}
          </div>
        </>
      )}
    </div>
  );




  return (
    <>
      {fieldGroupsShouldRender && (
        <div className="fields-container histological-grade">
          <p className="main-label">
            Histological grade
            <ModalInformation>
              {getNote2_histologicalGrade()}
            </ModalInformation>
          </p>
          {gleasonScore}
          {isupGradeGroup}
          {percentageGleasonPattern}
        </div>
      )}
    </>
  );
};

export const tumourExtentJSX = (fieldsDataList, numberOfCores, getFieldValue, setFieldValue) => {
  const tumourExtent1FieldData = fieldsDataList.find(field => field.name === 'tumourExtent1');
  const tumourExtent2FieldData = fieldsDataList.find(field => field.name === 'tumourExtent2');
  const tumourExtent3FieldData = fieldsDataList.find(field => field.name === 'tumourExtent3');

  const tumourExtent1ShouldRender = tumourExtent1FieldData !== undefined;
  const tumourExtent2ShouldRender = tumourExtent2FieldData !== undefined;
  const tumourExtent3ShouldRender = tumourExtent3FieldData !== undefined;

  const fieldGroupShouldRender =
    tumourExtent1ShouldRender
    || tumourExtent2ShouldRender
    || tumourExtent3ShouldRender;

  const clearTumourExtent2IfValueExist = () => {
    if (getFieldValue('tumourExtent2')) {
      window.alert("By choosing to set linear extent, length of tissues will be cleared.");
      setFieldValue('tumourExtent2', '');
    }
  };
  const clearTumourExtent3IfValueExist = () => {
    if (getFieldValue('tumourExtent3')) {
      window.alert("By choosing to set length of tissues, linear extent will be cleared.");
      setFieldValue('tumourExtent3', '');
    }
  };

  const numberOfPositiveCoreMaxValueFuntion =
    numberOfCores === 1 ? maxValue1
      : numberOfCores === 2 ? maxValue2
        : numberOfCores === 3 ? maxValue3
          : numberOfCores === 4 ? maxValue4
            : numberOfCores === 5 ? maxValue5
              : numberOfCores === 6 ? maxValue6
                : numberOfCores === 7 ? maxValue7
                  : numberOfCores === 8 ? maxValue8
                    : numberOfCores === 9 ? maxValue9
                      : numberOfCores === 10 ? maxValue10
                        : null;


  return (
    <>
      {fieldGroupShouldRender && (
        <div className="fields-container tumour-extent">
          <p className="main-label">
            Tumour extent
            <ModalInformation>
              {getNote3_tumorExtent()}
            </ModalInformation>
          </p>

          {tumourExtent1ShouldRender && (
            <div className="tumour-extent-field-container">
              <p>Number of positive cores/total number of cores</p>
              <div className="tumourExtent1-field-container field-container">
                <Field
                  {...tumourExtent1FieldData}
                  className="field tumourExtent1"
                  validate={[number,
                    ...numberOfPositiveCoreMaxValueFuntion ? [numberOfPositiveCoreMaxValueFuntion] : [],
                  ]}
                />
                <span>
                  /
                  {numberOfCores}
                </span>
              </div>
            </div>
          )}

          {tumourExtent2ShouldRender && (
            <>
              <p className="tumor-extent-fields-and-or-text">AND</p>
              <div className="tumour-extent-field-container field-container">
                <p>Length of tissues involved by carcinoma</p>
                <Field
                  {...tumourExtent2FieldData}
                  className="field tumourExtent2"
                  onClick={clearTumourExtent3IfValueExist}
                  validate={number}

                />
              </div>
            </>
          )}
          {tumourExtent3ShouldRender && (
            <>
              <p className="tumor-extent-fields-and-or-text">OR</p>
              <div className="tumour-extent-field-container field-container">
                <p>Linear extent of prostatic tissue involved by carcinoma</p>
                <Field
                  {...tumourExtent3FieldData}
                  className="field tumourExtent3"
                  onClick={clearTumourExtent2IfValueExist}
                  validate={[maxValue100, number]}
                />
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};


export const presentStatusCollectionJSX = (fieldsDataList, getFieldValue, setFieldValue) => {
  const perineuralInvasionFieldData = fieldsDataList.find(field => field.name === 'perineuralInvasion');
  const seminalDuctInvasionFieldData = fieldsDataList.find(field => field.name === 'seminalDuctInvasion');
  const lymphovascularInvasionFieldData = fieldsDataList.find(field => field.name === 'lymphovascularInvasion');
  const epeFieldData = fieldsDataList.find(field => field.name === 'epe');
  const intraductalCarcinomaFieldData = fieldsDataList.find(field => field.name === 'intraductalCarcinoma');
  const coexistentPathologyFieldData = fieldsDataList.find(field => field.name === 'coexistentPathology');
  const epeLocationSpecifiedFieldData = fieldsDataList.find(field => field.name === 'epeLocationSpecified');
  const coexistentPathologySpecifiedFieldData = fieldsDataList.find(field => field.name === 'coexistentPathologySpecified');


  const perineuralInvasionShouldRender = perineuralInvasionFieldData !== undefined;
  const seminalDuctInvasionShouldRender = seminalDuctInvasionFieldData !== undefined;
  const lymphovascularInvasionShouldRender = lymphovascularInvasionFieldData !== undefined;
  const epeShouldRender = epeFieldData !== undefined;
  const intraductalCarcinomaShouldRender = intraductalCarcinomaFieldData !== undefined;
  const coexistentPathologyShouldRender = coexistentPathologyFieldData !== undefined;

  const epeIsPresent = getFieldValue('epe') !== undefined && getFieldValue('epe') === 'present';
  const coexistentPathologyIsPresent = getFieldValue('coexistentPathology') !== undefined && getFieldValue('coexistentPathology') === 'present';
  const specifyEpeLocation = getFieldValue('specifyEpeLocation') !== undefined && getFieldValue('specifyEpeLocation');

  const epeLocationFieldsData = fieldsDataList.filter(field => [
    'epeLocationRightBase',
    'epeLocationRightMid',
    'epeLocationRightApex',
    'epeLocationLeftBase',
    'epeLocationLeftMid',
    'epeLocationLeftApex',
    'specifyEpeLocation',
  ].includes(field.name));

  const clearEpeLocationValues = () => {
    epeLocationFieldsData.map(field => field.name)
      .forEach(fieldName => {
        setFieldValue(fieldName, false);
      });
    setFieldValue('epeLocationSpecified', '');
  };

  const clearCoexistentPathologySpecified = () => {
    setFieldValue('coexistentPathologySpecified', '');
  }

  const perineuralInvasionField = (
    <div className="field-container perineuralInvasion">
      <p className="main-label">
        Perineural invasion
        <ModalInformation>
          {getNote4_perineuralInvasion()}
        </ModalInformation>
      </p>
      <Field
        {...perineuralInvasionFieldData}
        className="field"
      />
    </div>
  );
  const seminalDuctInvasionField = (
    <div className="field-container seminalDuctInvasion">
      <p className="main-label">
        Seminal vesicle/ejaculatory duct invasion
        <ModalInformation>
          {getNote5_semicalVesicleEjaculatoryDuctInvasion()}
        </ModalInformation>
      </p>
      <Field
        {...seminalDuctInvasionFieldData}
        className="field"
      />
    </div>
  );
  const lymphovascularInvasionField = (
    <div className="field-container lymphovascularInvasion">
      <p className="main-label">
        Lymphovascular invasion
        <ModalInformation>
          {getNote6_lymphovascularInvasion()}
        </ModalInformation>
      </p>
      <Field
        {...lymphovascularInvasionFieldData}
        className="field"
      />
    </div>
  );
  const epeField = (
    <div className="field-container epe">
      <p className="main-label">
        Extraprostatic extension (EPE)
        <ModalInformation>
          {getNote7_extraprostaticExtension()}
        </ModalInformation>
      </p>
      <Field
        {...epeFieldData}
        className="field"
        onChange={({ target: { value } }) => { if (value === 'not_identified') clearEpeLocationValues(); }}
      />
    </div>
  );

  const epeLocationFields = (
    <>
      <p>Location (select all thet apply)</p>
      {epeLocationFieldsData.map(fieldData => (
        <div key={fieldData.name}>
          <Field
            {...fieldData}
            className="field"
            disabled={!epeIsPresent}
          />
        </div>
      ))}
    </>
  );
  const epeSpecifyLocationField = (
    <div className="field-container">
      <Field
        {...epeLocationSpecifiedFieldData}
        className="field"
        disabled={!specifyEpeLocation}
      />
    </div>
  );

  const intraductalCarcinomaField = (
    <div className="field-container intraductalCarcinoma">
      <p className="main-label">
        Intraductal carcinoma of prostate
        <ModalInformation>
          {getNote8_intraductalCarcinomaOfProstate()}
        </ModalInformation>
      </p>
      <Field
        {...intraductalCarcinomaFieldData}
        className="field"
      />
    </div>
  );
  const coexistentPathologyField = (
    <div className="field-container coexistentPathology">
      <p className="main-label">
        Coexistent pathology
        <ModalInformation>
          {getNote9_coexistentPathology()}
        </ModalInformation>
      </p>
      <Field
        {...coexistentPathologyFieldData}
        className="field"
        onChange={({ target: { value } }) => { if (value === 'not_identified') clearCoexistentPathologySpecified(); }}
      />
    </div>
  );

  const coexistentPathologySpecifiedField = (
    <div className="field-container">
      <Field
        {...coexistentPathologySpecifiedFieldData}
        className="field"
        disabled={!coexistentPathologyIsPresent}
      />
    </div>
  );


  return (
    <div className="fields-container">
      {perineuralInvasionShouldRender && perineuralInvasionField}
      {seminalDuctInvasionShouldRender && seminalDuctInvasionField}
      {lymphovascularInvasionShouldRender && lymphovascularInvasionField}
      {epeShouldRender && epeField}
      {epeShouldRender && epeLocationFields}
      {epeShouldRender && epeSpecifyLocationField}
      {/*    {!epeShouldRender && <div className="show-in-print">{epeField}</div>} */}

      {/*   {!epeIsPresent && <div className="show-in-print">{epeLocationFields}</div>} */}
      {/*   {!specifyEpeLocation && <div className="show-in-print">{epeSpecifyLocationField}</div>} */}
      {intraductalCarcinomaShouldRender && intraductalCarcinomaField}
      {coexistentPathologyShouldRender && coexistentPathologyField}
      {coexistentPathologySpecifiedField}
    </div>
  );
};


export const termsAgreementJSX = (fieldData, pathologistName) => (
  <Field {...fieldData} label={<><b>{pathologistName}</b> accepts the terms of agreement</>} />);

export const regularSaveButtonJSX = (disableSubmitButton) => (
  <div className="button-note-container">
    <button
      type="submit"
      disabled={disableSubmitButton}
      className="regular-save-button btn--form"
    >
      Save
    </button>
    <ModalInformation>
      <h3>Save</h3>
      <p>Saves your changes. But will not mark the report as done.</p>
    </ModalInformation>
  </div>
);

export const submitAllAnalyzesButtonDemoJSX = (handleSubmitAllDemo, submitAllButtonProps, submitAllWarningText) => {
  const safeSubmitOnClick = () => {
    if (submitAllWarningText.length) {
      const confirmed = window.confirm(submitAllWarningText + " \nSubmit anyway?")
      if (confirmed) {
        handleSubmitAllDemo();
      }
    } else {
      handleSubmitAllDemo();
    }
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', alignSelf: 'flex-end', marginTop: '15px' }}>
      {submitAllButtonProps.disabled && <span style={{ color: 'red', maxWidth: '240px' }}>{submitAllButtonProps.title}</span>}
      {(!submitAllButtonProps.disabled && submitAllWarningText.length > 0) && <span style={{ color: 'red', maxWidth: '240px' }}>{submitAllWarningText}</span>}

      <div className="button-note-container">
        <Button
          type="button"
          // onClick={handleSubmitAllDemo}
          onClick={safeSubmitOnClick}
          color="primary"
          variant="contained"
          {...submitAllButtonProps}
        >
          Mark Analyses as done
        </Button>
        <ModalInformation>
          <h3>Mark All analyses as done</h3>
          <p>Marks all forms (specimen and case level analyses) as done. </p>
        </ModalInformation>
      </div>
    </div>
  )
}

export const saveAllAnalyzes = (saveAllUnsavedSpecimenAnalyzes, disableSaveAllButton) => (
  <Button
    onClick={saveAllUnsavedSpecimenAnalyzes}
    variant="contained"
    disabled={disableSaveAllButton}
  >
    Save All Analyses
  </Button>
)

export const reopenAnalysisButtonJSX = (goBackToStatusAwaitingAnalysis) => (
  <div className="button-note-container">
    <button
      type="button"
      className="btn--form"
      onClick={() => goBackToStatusAwaitingAnalysis()}>
      REOPEN CASE
      </button>
    <ModalInformation>
      <h3>Reopen Case</h3>
      <p>Makes it possible to edit analyses again.</p>
      <p>The case will appear under the Not Sumbmitted category again.</p>
    </ModalInformation>
  </div>
);

export const submitAnalysisButtonJSX = (handleMarkAsDone, shouldBeDisabled) => (
  <div className="button-note-container">
    <button
      type="button"
      onClick={() => handleMarkAsDone(true, false)}
      disabled={shouldBeDisabled}
      className="btn--form"
      title="Submit report">
      SUBMIT
      </button>
    <ModalInformation>
      <h3>Submit</h3>
      <p>Submits your report and close the core. </p>
      <p>You can later re-open the case.</p>
    </ModalInformation>
  </div>
);

export const submitAnalysisAndGoToNextButtonJSX = (handleSaveAndGoToNext, shouldBeDisabled) => (
  <div className="button-note-container">
    <button
      type="button"
      className="btn--form"

      onClick={() => handleSaveAndGoToNext()}
      disabled={shouldBeDisabled}>
      Submit and Go To Next Core
     </button>
    <ModalInformation>
      <h3>Submit and go to Next Core</h3>
      <p>Submits your report and sends you to the next core.</p>
      <p>You can later re-open the case.</p>
    </ModalInformation>
  </div>
);
